import { numberPx2rem } from '../utils/pxrem';

export type DividerProps = {
  height: number | string;
};

/**
 * 分割线
 * @param props
 * @returns
 */
export const Divider = (props: DividerProps) => {
  const height = numberPx2rem(props.height);
  return <div className="v-divider" style={{ height }}></div>;
};
